import React, { useEffect, useState } from "react";
import ToastNotification from "../../../../../components/ToastNotification/ToastNotification";
import { setToastNotification } from "../../../../../components/ToastNotification/service/toastNotificationSlice";
import merchant from "../../../../../assets/images/merchantStore.svg";
import SaveBtn from "../../../../../components/Buttons/SaveBtn";
import MultiBranchSelectField from "../../../../../components/AutoCompleteField/MultiBranchSelectField";
import plus from "../../../../../assets/images/baselinePlus.svg";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import TableSkeleton from "../../../../../components/Skeletons/TableSkeleton";
import editIcon from "../../../../../assets/images/edit-icon.svg";
import deleteIcon from "../../../../../assets/images/session-delete.svg";
import { useSelector } from "react-redux";
import { useAuthUser } from "react-auth-kit";
import { useDispatch } from "react-redux";
import styles from "./Merchant.module.css";
import {
  Box,
  Button,
  Dialog,
  FormControl,
  TextField,
  Typography,
} from "@mui/material";
import {
  resetDeleteSubmerchantSuccess,
  resetSaveSubmerchantSuccess,
} from "../../service/addSubmerchantSlice";
import RemoveContactsModal from "../../../Inbound/components/SyncedDataTab/Remove/RemoveContactsModal";
import { setTrigger } from "../../../Main/service/taskBoardUpdationSlice";
import { toggleTrigger } from "../../../Main/service/submerchantBranchUpdationSlice";
import TabsSwitcher from "./TabSwitcher";

const AddSubmerchant = (props: any) => {
  const {
    GetSubmerchantList,
    getSubmerchantLoading,
    getSubmerchantData,
    DeleteSubmerchant,
    deleteSubmerchantLoading,
    deleteSubmerchantSuccess,
    SaveSubmerchant,
    saveSubmerchantLoading,
    saveSubmerchantSuccess,
    isAddMerchantOpen,
    setIsAddMerchantOpen,
    fromAddButton,
    setFromAddButton,
    submerchantId,
    setSubmerchantId,
    submerchantName,
    setSubmerchantName,
    bankName,
    setBankName,
    accountNo,
    setAccountNo,
    merchantIdError,
    setMerchantIdError,
    merchantNameError,
    setMerchantNameError,
    bankNameError,
    setBankNameError,
    accountNoError,
    setAccountNoError,
    resetError,
    reset,
    UpdateSubmerchant,
    partnerId,
    setPartnerId,
    partnerName,
    setPartnerName,
    partnersalt,
    setPartnerSalt,
    partnerkey,
    setPartnerKey,
    partnerIdError,
    setPartnerIdError,
    partnerNameError,
    setPartnerNameError,
    saltError,
    setSaltError,
    keyError,
    setKeyError,
  } = props;
  const [merchantData, setMerchantData] = useState<any>();
  const [selectedBranches, setSelectedBranches] = useState<any>([]);
  const [validateBranch, setValidateBranch] = React.useState<boolean>(true);
  const branches = useSelector((state: any) => state.branch.branchList);
  const [mappedBranches, setMappedBranches] = useState<any>();
  const [isFromEdit, setIsFromEdit] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const auth = useAuthUser();
  const authUser = auth();
  const instituteDetails = authUser?.institute?.[0]?.instituteDetails;
  const dispatch = useDispatch();
  const [openDeleteModal, setOpenDeleteModal] = React.useState<boolean>(false);
  const [id, setId] = useState("");
  const [disableSubmerchantTab, setDisableSubmerchantTab] = useState(false);
  const [disablePartnershipTab, setDisablePartnershipTab] = useState(false);

  React.useEffect(() => {
    if (instituteDetails) {
      getMerchantList();
      setIsAddMerchantOpen(false);
      resetError();
      reset();
      dispatch(resetSaveSubmerchantSuccess());
      dispatch(resetDeleteSubmerchantSuccess());
      setId("");
      setOpenDeleteModal(false);
      setDisablePartnershipTab(false);
      setDisableSubmerchantTab(false);
    }
  }, [deleteSubmerchantSuccess, saveSubmerchantSuccess]);

  const getMerchantList = () => {
    GetSubmerchantList(instituteDetails?.id);
  };

  useEffect(() => {
    if (getSubmerchantData) {
      setMerchantData(getSubmerchantData);
    }
  }, [getSubmerchantData]);

  const handleDelete = () => {
    DeleteSubmerchant({ id: id });
  };

  const onAssigneeChange = React.useCallback(
    (event: any, newAssignees: any) => {
      const mappedAssignees = newAssignees?.map((assignee: any) => ({
        branchId: assignee.id,
        branchName: `${assignee.branchName}`,
      }));
      setMappedBranches(mappedAssignees);
      setSelectedBranches(newAssignees);
      if (newAssignees?.length > 0) {
        setValidateBranch(true);
      } else {
        setValidateBranch(false);
      }
    },
    []
  );

  const branchList =
    authUser?.institute[0]?.role === "Admin"
      ? branches &&
        branches?.filter((d: any) => d?.id === authUser?.institute[0]?.branchId)
      : branches;

  const handleSubmit = () => {
    if (activeTab === 0) {
      if (submerchantId === "" || submerchantId?.length !== 11) {
        setMerchantIdError(true);
        dispatch(
          setToastNotification({
            message: String("Enter Valid Merchant Id"),
            type: "error",
            snackOpen: true,
          })
        );
        return;
      } else {
        setMerchantIdError(false);
      }
      if (submerchantName === "") {
        setMerchantNameError(true);
        dispatch(
          setToastNotification({
            message: String("Enter Valid Merchant Name"),
            type: "error",
            snackOpen: true,
          })
        );
        return;
      } else {
        setMerchantNameError(false);
      }
    } else {
      if (partnerId === "" || partnerId?.length !== 11) {
        setPartnerIdError(true);
        dispatch(
          setToastNotification({
            message: String("Enter Valid Partner Id"),
            type: "error",
            snackOpen: true,
          })
        );
        return;
      } else {
        setPartnerIdError(false);
      }
      if (partnerName === "") {
        setPartnerNameError(true);
        dispatch(
          setToastNotification({
            message: String("Enter Valid Partner Name"),
            type: "error",
            snackOpen: true,
          })
        );
        return;
      } else {
        setPartnerNameError(false);
      }
      if (partnerkey === "" || partnerkey?.length !== 9) {
        setKeyError(true);
        dispatch(
          setToastNotification({
            message: String("Enter Valid Partner Key"),
            type: "error",
            snackOpen: true,
          })
        );
        return;
      } else {
        setKeyError(false);
      }
      if (partnersalt === "" || partnersalt?.length !== 9) {
        setSaltError(true);
        dispatch(
          setToastNotification({
            message: String("Enter Valid Partner Salt"),
            type: "error",
            snackOpen: true,
          })
        );
        return;
      } else {
        setSaltError(false);
      }
    }

    if (bankName === "") {
      setBankNameError(true);
      dispatch(
        setToastNotification({
          message: String("Enter Valid Bank Name"),
          type: "error",
          snackOpen: true,
        })
      );
      return;
    } else {
      setBankNameError(false);
    }

    if (accountNo === "" || accountNo?.length < 10) {
      setAccountNoError(true);
      dispatch(
        setToastNotification({
          message: String("Enter Valid Account Number"),
          type: "error",
          snackOpen: true,
        })
      );
      return;
    } else {
      setAccountNoError(false);
    }
    if (mappedBranches === undefined || mappedBranches?.length === 0) {
      dispatch(
        setToastNotification({
          message: String("Please Select branch"),
          type: "error",
          snackOpen: true,
        })
      );
      return;
    }

    const body = {
      instituteId: instituteDetails?.id,
      subMerchantId: submerchantId,
      subMerchantName: submerchantName,
      bankName: bankName,
      accountNumber: accountNo,
      branchData: mappedBranches,
      modelType: "SUBMERCHANT_MODEL",
    };
    const updateBody = {
      instituteId: instituteDetails?.id,
      subMerchantId: submerchantId,
      subMerchantName: submerchantName,
      bankName: bankName,
      accountNumber: accountNo,
      branchData: mappedBranches,
      id: id,
      modelType: "SUBMERCHANT_MODEL",
    };

    const partnerShipBody = {
      instituteId: instituteDetails?.id,
      partnerName: partnerName,
      partnerId: partnerId,
      bankName: bankName,
      accountNumber: accountNo,
      branchData: mappedBranches,
      partnerKey: partnerkey,
      partnerSalt: partnersalt,
      modelType: "PARTNERSHIP_MODEL",
    };

    const partnerShipUpdateBody = {
      instituteId: instituteDetails?.id,
      partnerName: partnerName,
      partnerId: partnerId,
      bankName: bankName,
      accountNumber: accountNo,
      branchData: mappedBranches,
      partnerKey: partnerkey,
      partnerSalt: partnersalt,
      modelType: "PARTNERSHIP_MODEL",
      id: id,
    };

    if (activeTab === 0) {
      isFromEdit ? UpdateSubmerchant(updateBody) : SaveSubmerchant(body);
    } else {
      isFromEdit
        ? UpdateSubmerchant(partnerShipUpdateBody)
        : SaveSubmerchant(partnerShipBody);
    }
    setIsFromEdit(false);
    dispatch(toggleTrigger());
  };

  useEffect(() => {
    const isPartnerShipExist =
      getSubmerchantData?.length > 0 &&
      getSubmerchantData?.some(
        (d: any) => d?.modelType === "PARTNERSHIP_MODEL"
      );
    setDisablePartnershipTab(isPartnerShipExist);
  }, [getSubmerchantData]);

  return (
    <>
      {getSubmerchantData?.length > 0 && (
        <div>
          <div className={styles.merchantAdd}>
            <div>Bank Details</div>
            <div
              style={{
                backgroundColor: "rgb(250, 254, 253)",
                border: "1px solid #11C89B",
                padding: "5px",
                borderRadius: "8px",
                color: "#11C89B",
                margin: "20px 0px",
                cursor: "pointer",
              }}
              onClick={() => {
                setIsAddMerchantOpen(true);
                setFromAddButton(true);
                reset();
                resetError();
                setSelectedBranches([]);
                setActiveTab(0);
              }}
            >
              Add Submerchant Details{" "}
              <img src={plus} style={{ marginTop: "5px" }} />
            </div>
          </div>
          <div className={styles.merchantInfoHeading}>
            Submerchant Information
          </div>
          <div className={styles.container}>
            {getSubmerchantLoading ? (
              <TableSkeleton />
            ) : (
              <div className={styles.tableContainer}>
                <table className={styles.tableOfMerchant}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          borderBottom: "1px solid #ddd",
                          background: " #e8f5e9",
                          fontWeight: "bold",
                        }}
                      >
                        ID
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          borderBottom: "1px solid #ddd",
                          background: " #e8f5e9",
                          fontWeight: "bold",
                        }}
                      >
                        Name
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          borderBottom: "1px solid #ddd",
                          background: " #e8f5e9",
                          fontWeight: "bold",
                        }}
                      >
                        Bank Name
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          borderBottom: "1px solid #ddd",
                          background: " #e8f5e9",
                          fontWeight: "bold",
                        }}
                      >
                        Account No
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          borderBottom: "1px solid #ddd",
                          background: " #e8f5e9",
                          fontWeight: "bold",
                        }}
                      >
                        Branch
                      </th>
                      <th
                        style={{
                          padding: "12px",
                          textAlign: "left",
                          borderBottom: "1px solid #ddd",
                          background: " #e8f5e9",
                          fontWeight: "bold",
                        }}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {merchantData &&
                      merchantData?.map((d: any) => {
                        return (
                          <tr>
                            <td
                              style={{
                                padding: "12px",
                                textAlign: "left",
                                borderBottom: "1px solid #ddd",
                                color: "#555",
                              }}
                            >
                              <span className={styles.idBox}>
                                {d?.modelType === undefined ||
                                d?.modelType === null ||
                                d?.modelType === "SUBMERCHANT_MODEL"
                                  ? d?.appConfigData?.subMerchantId
                                    ? d?.appConfigData?.subMerchantId
                                    : "-"
                                  : d?.appConfigData?.partnerId
                                  ? d?.appConfigData?.partnerId
                                  : "-"}
                              </span>
                            </td>
                            <td
                              style={{
                                textTransform: "capitalize",
                                padding: "12px",
                                textAlign: "left",
                                borderBottom: "1px solid #ddd",
                                color: "#555",
                              }}
                            >
                              {d?.modelType === undefined ||
                              d?.modelType === null ||
                              d?.modelType === "SUBMERCHANT_MODEL"
                                ? d?.appConfigData?.subMerchantName
                                  ? d?.appConfigData?.subMerchantName
                                  : "-"
                                : d?.appConfigData?.partnerName
                                ? d?.appConfigData?.partnerName
                                : "-"}
                            </td>
                            <td
                              className={styles.bankName}
                              style={{
                                textTransform: "capitalize",
                                padding: "12px",
                                textAlign: "left",
                                borderBottom: "1px solid #ddd",
                                color: "#555",
                              }}
                            >
                              {d?.appConfigData?.bankName
                                ? d?.appConfigData?.bankName
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                textAlign: "left",
                                borderBottom: "1px solid #ddd",
                                color: "#555",
                              }}
                            >
                              <span className={styles.accountNumber}>
                                {d?.appConfigData?.accountNumber
                                  ? d?.appConfigData?.accountNumber
                                  : "-"}
                              </span>
                            </td>
                            <td
                              style={{
                                textTransform: "capitalize",
                                padding: "12px",
                                textAlign: "left",
                                borderBottom: "1px solid #ddd",
                                color: "#555",
                              }}
                            >
                              {d?.appConfigData?.branchData
                                ? d?.appConfigData?.branchData.length <= 3
                                  ? d?.appConfigData?.branchData
                                      .map(
                                        (branch: any) => `${branch?.branchName}`
                                      )
                                      .join(", ")
                                  : `${d?.appConfigData?.branchData
                                      .slice(0, 3)
                                      .map(
                                        (branch: any) => `${branch?.branchName}`
                                      )
                                      .join(", ")}...`
                                : "-"}
                            </td>
                            <td
                              className={styles.actionButtons}
                              style={{
                                // pointerEvents:
                                //   d?.accessLevel === "BRANCH" ? "auto" : "none",

                                // opacity:
                                //   d?.accessLevel === "INSTITUTE" ? 0.6 : 1,
                                // cursor:
                                //   d?.accessLevel === "INSTITUTE"
                                //     ? "not-allowed"
                                //     : "pointer",
                                cursor: "pointer",
                                padding: "12px",
                                textAlign: "left",
                                borderBottom: "1px solid #ddd",
                                color: "#555",
                              }}
                            >
                              <div
                                className={styles.editBtn}
                                onClick={() => {
                                  setIsAddMerchantOpen(true);
                                  setSubmerchantId(
                                    d?.appConfigData?.subMerchantId
                                  );
                                  setBankName(d?.appConfigData?.bankName);
                                  setSubmerchantName(
                                    d?.appConfigData?.subMerchantName
                                  );
                                  setAccountNo(d?.appConfigData?.accountNumber);
                                  // setSelectedBranches(
                                  //   d?.appConfigData?.branchData?.map(
                                  //     (d: any) => {
                                  //       return {
                                  //         id: d?.branchId,
                                  //         branchName: d?.branchName,
                                  //       };
                                  //     }
                                  //   )
                                  // );
                                  const matchingBranches =
                                    branchList?.filter((branch: any) =>
                                      d?.appConfigData?.branchData.some(
                                        (branchObj: any) =>
                                          branchObj.branchId === branch.id
                                      )
                                    ) || [];
                                  // setSelectedBranches(
                                  //   matchingBranches.map((branch: any) => ({
                                  //     id: branch.id,
                                  //     branchName: branch.branchName,
                                  //   }))
                                  // );
                                  setSelectedBranches(matchingBranches);
                                  setMappedBranches(
                                    d?.appConfigData?.branchData
                                  );
                                  setFromAddButton(true);
                                  setIsFromEdit(true);
                                  setPartnerKey(d?.appConfigData?.partnerKey);
                                  setPartnerSalt(d?.appConfigData?.partnerSalt);
                                  if (d?.modelType === "PARTNERSHIP_MODEL") {
                                    setActiveTab(1);
                                    setDisableSubmerchantTab(true);
                                    setPartnerId(d?.appConfigData?.partnerId);
                                    setPartnerName(
                                      d?.appConfigData?.partnerName
                                    );
                                    setPartnerKey(d?.appConfigData?.partnerKey);
                                    setPartnerSalt(
                                      d?.appConfigData?.partnerSalt
                                    );
                                  } else {
                                    setActiveTab(0);
                                    setDisablePartnershipTab(true);
                                  }
                                  setId(d?.id);
                                }}
                              >
                                <img src={editIcon} height={"15px"} />
                              </div>
                              <div
                                className={styles.deleteBtn}
                                onClick={() => {
                                  setOpenDeleteModal(true);
                                  setId(d?.id);
                                }}
                              >
                                <img src={deleteIcon} height={"20px"} />
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {/* <Dialog
        open={isAddMerchantOpen}
        sx={{
          // zIndex: "9999999",
          minWidth: "600px",
          maxHeight: activeTab === 0 ? "800PX" : "900PX",
          "& .MuiDialog-paper": {
            width: "100%",
            maxWidth: "450px",
            padding: "10px",
            borderRadius: "12px",
            boxShadow:
              "0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)",
            left: 0,
            background: "#FFFFFF",
            // overflow: "scroll",
            position: "relative",
          },
        }}
      > */}
      <Dialog
        open={isAddMerchantOpen}
        sx={{
          "& .MuiDialog-paper": {
            width: "100%",
            maxWidth: "500px",
            maxHeight: "90vh",
            borderRadius: "12px",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {/* <Button
          sx={{
            color: "#667085",
            padding: "0px",
            display: "flex",
            justifyContent: "flex-end",
            position: "sticky",
            top: "10px",
            right: "100px",
            zIndex: "99999999",
            "&:hover": {
              backgroundColor: "transparent", // removes hover background
            },
          }}
          onClick={() => setIsAddMerchantOpen(false)}
        >
          <CloseOutlinedIcon />
        </Button> */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 20px",
            borderBottom: "1px solid #eee",
          }}
        >
          <div style={{ fontWeight: 600 }}>
            {activeTab === 0 ? "Add Submerchant" : "Add Partnership"}
          </div>

          <CloseOutlinedIcon
            style={{ cursor: "pointer", color: "#667085" }}
            onClick={() => setIsAddMerchantOpen(false)}
          />
        </div>
        <div
          // style={{
          //   display: "flex",
          //   flexDirection: "column",
          //   justifyContent: "center",
          //   padding: "20px",

          // }}
          style={{
            overflowY: "auto",
            padding: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              // margin: "10px 0px",
            }}
          >
            <img src={merchant} />
            <div style={{ margin: "15px 0px" }}>
              <TabsSwitcher
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                disablePartnershipTab={disablePartnershipTab}
                disableSubmerchantTab={disableSubmerchantTab}
              />
            </div>
            <div
              style={{
                backgroundColor: "rgb(250, 254, 253)",
                border: "1px solid #11C89B",
                padding: "10px",
                borderRadius: "8px",
                color: "#11C89B",
                marginTop: "5px",
              }}
            >
              {activeTab === 0
                ? "Add New Submerchant Details"
                : "Add New Partnership Details"}
            </div>
          </div>
          {activeTab === 0 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "10px 0px 5px 0px",
              }}
            >
              <FormControl sx={{ m: 1, margin: "6px 0", width: "45%" }}>
                <Typography
                  sx={{
                    color: "#142C44",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "18px",
                    marginBottom: "6px",
                  }}
                >
                  Submerchant Id <span style={{ color: "#EC3939" }}>*</span>
                </Typography>
                <TextField
                  type="alphanumeric"
                  id="amountReceived"
                  required
                  // placeholder="₹"
                  value={submerchantId}
                  variant="outlined"
                  onChange={(e: any) => {
                    setSubmerchantId(e?.target?.value);
                  }}
                  error={merchantIdError}
                  // helperText={merchantIdError ? "Enter Valid Id" : ""}
                  inputProps={{ maxLength: 11 }}
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: "#B1B1B1",
                      fontWeight: "300",
                      fontSize: "12px",
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "10px 16px",
                    },
                  }}
                />
              </FormControl>
              <FormControl sx={{ m: 1, margin: "6px 0", width: "45%" }}>
                <Typography
                  sx={{
                    color: "#142C44",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "18px",
                    marginBottom: "6px",
                  }}
                >
                  Submerchant Name <span style={{ color: "#EC3939" }}>*</span>
                </Typography>
                <TextField
                  type="string"
                  id="amountReceived"
                  required
                  // placeholder="₹"
                  value={submerchantName}
                  variant="outlined"
                  onChange={(e: any) => {
                    setSubmerchantName(e?.target?.value);
                  }}
                  error={merchantNameError}
                  // helperText={amountError || " "}
                  inputProps={{ min: "0" }}
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: "#B1B1B1",
                      fontWeight: "300",
                      fontSize: "12px",
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "10px 16px",
                    },
                  }}
                />
              </FormControl>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "10px 0px 5px 0px",
              }}
            >
              <FormControl sx={{ m: 1, margin: "6px 0", width: "45%" }}>
                <Typography
                  sx={{
                    color: "#142C44",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "18px",
                    marginBottom: "6px",
                  }}
                >
                  Partner Id <span style={{ color: "#EC3939" }}>*</span>
                </Typography>
                <TextField
                  type="alphanumeric"
                  id="amountReceived"
                  required
                  // placeholder="₹"
                  value={partnerId}
                  variant="outlined"
                  onChange={(e: any) => {
                    setPartnerId(e?.target?.value);
                  }}
                  error={partnerIdError}
                  // helperText={merchantIdError ? "Enter Valid Id" : ""}
                  inputProps={{ maxLength: 11 }}
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: "#B1B1B1",
                      fontWeight: "300",
                      fontSize: "12px",
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "10px 16px",
                    },
                  }}
                />
              </FormControl>
              <FormControl sx={{ m: 1, margin: "6px 0", width: "45%" }}>
                <Typography
                  sx={{
                    color: "#142C44",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "18px",
                    marginBottom: "6px",
                  }}
                >
                  Partner Name <span style={{ color: "#EC3939" }}>*</span>
                </Typography>
                <TextField
                  type="string"
                  id="amountReceived"
                  required
                  // placeholder="₹"
                  value={partnerName}
                  variant="outlined"
                  onChange={(e: any) => {
                    setPartnerName(e?.target?.value);
                  }}
                  error={partnerNameError}
                  // helperText={amountError || " "}
                  inputProps={{ min: "0" }}
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: "#B1B1B1",
                      fontWeight: "300",
                      fontSize: "12px",
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "10px 16px",
                    },
                  }}
                />
              </FormControl>
            </div>
          )}
          <FormControl sx={{ m: 1, margin: "6px 0", width: "100%" }}>
            <Typography
              sx={{
                color: "#142C44",
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "18px",
                marginBottom: "6px",
              }}
            >
              Bank Name <span style={{ color: "#EC3939" }}>*</span>
            </Typography>
            <TextField
              type="string"
              id="amountReceived"
              required
              // placeholder="₹"
              value={bankName}
              variant="outlined"
              onChange={(e: any) => {
                setBankName(e?.target?.value);
              }}
              error={bankNameError}
              // helperText={amountError || " "}
              inputProps={{ min: "0" }}
              sx={{
                "& .MuiInputLabel-root": {
                  color: "#B1B1B1",
                  fontWeight: "300",
                  fontSize: "12px",
                },
                "& .MuiOutlinedInput-input": {
                  padding: "10px 16px",
                },
              }}
            />
          </FormControl>
          <FormControl
            sx={{
              m: 1,
              margin: "6px 0",
              width: "100%",
            }}
          >
            <Typography
              sx={{
                color: "#142C44",
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "18px",
              }}
            >
              Account Number <span style={{ color: "#EC3939" }}>*</span>
            </Typography>
            <TextField
              type="number"
              id="amountReceived"
              required
              value={accountNo}
              variant="outlined"
              onChange={(e: any) => {
                setAccountNo(e?.target?.value);
              }}
              error={accountNoError}
              // helperText={amountError || " "}
              inputProps={{ maxLength: 18 }}
              sx={{
                "& .MuiInputLabel-root": {
                  color: "#B1B1B1",
                  fontWeight: "300",
                  fontSize: "12px",
                },
                "& .MuiOutlinedInput-input": {
                  padding: "10px 16px",
                },
              }}
            />
          </FormControl>

          {/* {fromAddButton && ( */}
          <div
            style={{
              flexBasis: "100%",
            }}
          >
            <MultiBranchSelectField
              id="branchId"
              label="Branch"
              options={branchList}
              onChange={onAssigneeChange}
              value={selectedBranches}
              disableClearable={selectedBranches?.length > 0 ? true : false}
              required={true}
              validState={validateBranch}
            />
          </div>
          {activeTab === 1 && (
            <>
              <FormControl
                sx={{
                  m: 1,
                  margin: "6px 0",
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    color: "#142C44",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "18px",
                  }}
                >
                  Salt <span style={{ color: "#EC3939" }}>*</span>
                </Typography>
                <TextField
                  type="alphanumeric"
                  id="amountReceived"
                  required
                  value={partnersalt}
                  variant="outlined"
                  onChange={(e: any) => {
                    setPartnerSalt(e?.target?.value);
                  }}
                  error={saltError}
                  // helperText={amountError || " "}
                  inputProps={{ maxLength: 9 }}
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: "#B1B1B1",
                      fontWeight: "300",
                      fontSize: "12px",
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "10px 16px",
                    },
                  }}
                />
              </FormControl>
              <FormControl
                sx={{
                  m: 1,
                  margin: "6px 0",
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    color: "#142C44",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "18px",
                  }}
                >
                  Key <span style={{ color: "#EC3939" }}>*</span>
                </Typography>
                <TextField
                  type="alphanumeric"
                  id="amountReceived"
                  required
                  value={partnerkey}
                  variant="outlined"
                  onChange={(e: any) => {
                    setPartnerKey(e?.target?.value);
                  }}
                  error={keyError}
                  // helperText={amountError || " "}
                  inputProps={{ maxLength: 9 }}
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: "#B1B1B1",
                      fontWeight: "300",
                      fontSize: "12px",
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "10px 16px",
                    },
                  }}
                />
              </FormControl>
            </>
          )}
          {/* )} */}
          <div
            style={{
              margin: "15px 0px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <SaveBtn
              onClick={() => {
                handleSubmit();
              }}
              loader={saveSubmerchantLoading}
            />
          </div>
        </div>
      </Dialog>
      <RemoveContactsModal
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        deleteConfirm={handleDelete}
        loading={deleteSubmerchantLoading}
        text={" Are you sure you want to delete this merchant?"}
      />
    </>
  );
};

export default AddSubmerchant;
